import accents from 'remove-accents'
export default function() {
    $(document).on('change', '.email-field', function() {
        let textNoAcc = $(this).val()
        $(this).val(accents.remove(textNoAcc))
    });
}